import { httpGet, httpPost } from "../connection";

export async function getCaseAssignments(
  values = { case_id: null },
  params = {}
) {
  return await httpGet(`/cases/${values.case_id}/case-assignments`, values);
}

export async function assignUsersToCase(
  values = { userIDs: null, case_id: null }
) {
  return await httpPost(`/cases/${values.case_id}/case-assignments/add`, {
    userIDs: values.userIDs,
  });
}

export async function removeUsersFromCase(
  values = { userIDs: null, case_id: null }
) {
  return await httpPost(`/cases/${values.case_id}/case-assignments/remove`, {
    userIDs: values.userIDs,
  });
}

export async function assignUserGroup(values = { case_id: null }) {
  return await httpPost(
    `/cases/${values.case_id}/case-assignments/assign-user-group`,
    values
  );
}

export async function unassignUserGroup(values = { case_id: null }) {
  return await httpPost(
    `/cases/${values.case_id}/case-assignments/unassign-user-group`,
    values
  );
}

const CaseAssignmentsApi = {
  getCaseAssignments,
  assignUsersToCase,
  removeUsersFromCase,
  assignUserGroup,
  unassignUserGroup,
};

export default CaseAssignmentsApi;
